import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import boardReducer from './boardSlice';
import taskReducer from './taskSlice';
import uiReducer from './uiSlice';
import sprintReducer from './sprintSlice';
import timeTrackingReducer from './timeTrackingSlice';
import epicReducer from './epicSlice';
import teamsReducer from './slices/teamsSlice';
import groupReducer from './groupSlice';
import columnReducer from './columnSlice';
import favoritesReducer from './favoritesSlice';
import workspaceReducer from './workspaceSlice';
import folderReducer from './slices/folderSlice';
import discoveryReducer from './slices/discoverySlice';
import recentsReducer from './slices/recentsSlice';
import dashboardReducer from './slices/dashboardSlice';
import activityReducer from './slices/activitySlice';
import commentsReducer from './slices/commentsSlice';
import subtasksReducer from './slices/subtasksSlice';

// Redux persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'workspaces'], // Persist auth and workspace state
};

// Combine all reducers
const rootReducer = combineReducers({
  auth: authReducer,
  favorites: favoritesReducer,
  workspaces: workspaceReducer,
  folders: folderReducer,
  discovery: discoveryReducer,
  recents: recentsReducer,
  dashboard: dashboardReducer,
  activity: activityReducer,
  comments: commentsReducer,
  subtasks: subtasksReducer,
  boards: boardReducer,
  tasks: taskReducer,
  ui: uiReducer,
  sprints: sprintReducer,
  timeTracking: timeTrackingReducer,
  epics: epicReducer,
  teams: teamsReducer,
  groups: groupReducer,
  columns: columnReducer,
});

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['ui/openModal', 'persist/PERSIST', 'persist/REHYDRATE'],
        // Ignore these paths in the state
        ignoredPaths: ['ui.modalData'],
      },
    }),
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
